import React from "react";
import ContactPersonDTO from "features/contractualAccounts/dtos/ContactPersonDTO";
import ContactPerson from "features/contractualAccounts/components/ContactPerson";
import { useTranslation } from "react-i18next";

interface Props {
  person: ContactPersonDTO;
  title?: string;
  className?: string;
}

const ContactPersonInline = ({
  person,
  title,
  className
}: Props) => {

// translations
const tLabels = useTranslation("contractualAccounts\\contractualAccounts").t;

  title = tLabels("contactPersonInline.cardTitle");
  
  return (
    <div className={className}>
      <span className="text-muted mr-1">{title}</span>
      <span>
        <ContactPerson person={person} />
      </span>
    </div>
  );
};

export default ContactPersonInline;
